module.exports = __webpack_public_path__ + "img/bg-landpage.3887467c.svg";